<template>
  <div>
    <b-card
      v-if="gateway.payment_priority == 1704"
      :title="gateway.website_name"
      :sub-title="gateway.website"
    >
      <b-card-body class="pl-0 pr-0 pt-2 pb-2">
        <AddCard
          v-bind:afterdone="getCardList"
          v-bind:canceled="getCardList"
          v-bind:justShoraka="'partners'"
        ></AddCard>
        <b-modal id="newShare" title="تسویه جدید" no-stacking hide-footer>
          <b-alert variant="danger" :show="error != null">
            {{ error }}
          </b-alert>
          <b-form-group label="شماره حساب:">
            <b-input-group>
              <template v-slot:append>
                <b-button
                  variant="success"
                  @click="$bvModal.show('addcard-modal')"
                  >جدید</b-button
                >
              </template>
              <v-select-s
                style="width: calc(100% - 60px)"
                dir="rtl"
                :options="userCards"
                :reduce="(item) => item.value"
                label="text"
                :value="itemToSave.detail_id"
                v-model="itemToSave.detail_id"
                :dropdown-should-open="dropdownShouldOpen"
                :autocomplete="'on'"
              ></v-select-s>
            </b-input-group>
          </b-form-group>
          <b-form-group label="مبلغ (ریال):">
            <NumberSeprator
              placeholder="مبلغ را به ریال وارد کنید"
              v-model="itemToSave.amount"
            >
            </NumberSeprator>
          </b-form-group>
          <b-form-group label="بابت:">
            <MDDropdown
              id="select_category"
              group="122"
              v-model="itemToSave.babat"
            ></MDDropdown>
          </b-form-group>
          <b-form-group>
            <b-button variant="warning" :class="'ml-2 '" @click="closeTashom"
              >انصراف</b-button
            >
            <b-button
              variant="success"
              class="ml-2"
              @click="Save"
              :disabled="disableSave"
              :class="
                'ml-2 ' +
                (isloading == true ? 'pl-7 spinner spinner-light' : '')
              "
              >ذخیره</b-button
            >
            <b-button
              variant="primary"
              class="ml-2"
              @click="SaveAndSend"
              :disabled="disablePay"
              :class="
                'ml-2 ' +
                (isloadingSaveAndSend == true
                  ? 'pl-7 spinner spinner-light'
                  : '')
              "
              >ذخیره و پرداخت</b-button
            >
          </b-form-group>
        </b-modal>
        <b-form-group>
          <b-button variant="success" @click="ShowShareModal()"
            >تسویه جدید</b-button
          >

          <b-button class="ml-5" variant="danger" @click="showModal()"
            >بارگذاری اکسل</b-button
          >
        </b-form-group>
      </b-card-body>
      <hr />
      <b-tabs>
        <b-tab
          title="تسویه حساب"
          href="#All"
          :active="$route.hash === '#All'"
          @click="$router.push($route.path + '#All')"
        >
          <TableShowData
            :url="donetable.url"
            :fields="donetable.fields"
            :params="donetable.params"
            :excelroute="'excel'"
          >
          </TableShowData>
        </b-tab>
        <!-- <b-tab
          title="شارژ حساب (واریز)"
        
        
         href="#ChargeAccountUrl"
          :active="$route.hash === '#ChargeAccountUrl'"
          @click="
            $router.push(
             $route.path + '#ChargeAccountUrl'
            )
          "
        >
        <TableShowData
          v-if="$route.hash === '#ChargeAccountUrl'"
          :url="donetable.ChargeAccountUrl"
          :fields="donetable.fields"
          :params="donetable.params"
          :excelroute="'excel'"
        >
        </TableShowData>
        </b-tab>
        <b-tab
          title="انتقال وجه (انجام شده)"
          href="#TransferDone"
          :active="$route.hash === '#TransferDone'"
          @click="
            $router.push(
             $route.path + '#TransferDone'
            )
          "
        >
        <TableShowData
          v-if="$route.hash === '#TransferDone'"
          :url="donetable.TransferDone"
          :fields="donetable.fields"
          :params="donetable.params"
          :excelroute="'excel'"
        >
        </TableShowData>
        </b-tab>
        <b-tab
          title="انتقال وجه (لغو شده)"
          href="#TransferUndone"
          :active="$route.hash === '#TransferUndone'"
          @click="
            $router.push(
             $route.path + '#TransferUndone'
            )
          "
        >
        <TableShowData
          v-if="$route.hash === '#TransferUndone'"
          :url="donetable.TransferUndone"
          :fields="donetable.fields"
          :params="donetable.params"
          :excelroute="'excel'"
        >
        </TableShowData>
        </b-tab> -->
      </b-tabs>
    </b-card>
    <b-card
      v-if="gateway.payment_priority != 1704"
      :title="gateway.website_name"
      :sub-title="gateway.website"
    >
      <b-card-body class="pl-0 pr-0 pt-2 pb-2">
        <TableShowData
          :url="settlementstable.url"
          :fields="settlementstable.fields"
          :params="settlementstable.params"
          :btns="settlementstable.btns"
          :excelroute="'excel'"
        >
        </TableShowData>
      </b-card-body>
    </b-card>
    <modal-custom
      v-show="showqrc"
      @close="closeModal"
      :size="window.width >= 768 ? 'w-50' : 'w-75'"
      :height="window.width >= 768 ? 'h-75' : 'h-75'"
      v-if="showqrc"
      :noHeader="false"
    >
      <template v-slot:header>
        <h4><strong>پرداخت از طریق بارگذاری فایل اکسل</strong></h4>
      </template>
      <template v-slot:body>
        <div id="app" class="container">
          <b-row>
            <b-col md="8" sm="8" cols="12">
              <file-uploader
                ref="upload_excel"
                v-model="files"
                @loadingTable="loading"
              ></file-uploader>
            </b-col>

            <b-col md="4" sm="4" cols="12">
              <a
                href="https://shepa.com/wp-content/uploads/2022/07/فایل-نمونه.xlsx"
                download
              >
                <b-button block>دریافت نمونه فایل</b-button>
              </a>
            </b-col>
          </b-row>
          <b-row class="mt-5">
            <b-col cols="12">
              <!-- <TableShowData /> -->
              <b-card title="محتویات فایل اکسل">
                <b-skeleton-table
                  v-if="loadingTable"
                  :rows="3"
                  :columns="4"
                  :table-props="{ bordered: true, striped: true }"
                ></b-skeleton-table>

                <b-table
                  v-else
                  :items="loadedConentExcel"
                  :fields="fields"
                  responsive
                  style="width: 100%"
                  striped
                  hover
                  show-empty
                  empty-text="آیتمی جهت نمایش وجود ندارد"
                ></b-table>
              </b-card>
            </b-col>
          </b-row>
        </div>
      </template>
      <template v-slot:footer>
        <b-form-group>
          <b-button variant="danger" @click="closeModal">انصراف</b-button>

          <b-button
            class="ml-5"
            variant="success"
            @click.prevent="payExcelList"
            :class="
              'ml-3 ' +
              (isBusyExcel ? 'spinner spinner-light spinner-right' : '')
            "
            >ذخیره و پرداخت</b-button
          >
        </b-form-group>
      </template>
    </modal-custom>
  </div>
</template>
<style lang="scss">
.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
.ltr-dir {
  direction: ltr;
}
</style>
<script>
import vSelect from "vue-select";
import httpHelper from "../../helpers/httpHelper";
import TableShowData from "../../components/table.vue";
import persianDate from "../../helpers/persianDate";
import MDDropdown from "../../components/MDDropdown";
import AddCard from "../BankCards/AddCard";
import NumberSeprator from "../../components/numberSeprator";
import _ from "lodash";
import Button from "../../view/pages/vue-bootstrap/Button.vue";
import modal from "@/components/modal";
import fileUploader from "@/components/fileUploader";
import {
  GET_CONTENT_EXCEL,
  PAY_WITH_CONTENT_EXCEL,
} from "@/core/services/store/getContentExcel.module";
import moment from "jalali-moment";

export default {
  name: "ShareAndSettlement",
  data() {
    return {
      settlementstable: {
        url: "gateway_satt/" + this.$route.params.id,
        fields: [
          {
            key: "shaba_number",
            label: "شماره شبا",
          },
          {
            key: "nickname",
            label: "مالک حساب",
          },
          {
            key: "bankName",
            label: "نام بانک",
          },
          {
            key: "created_at",
            label: "تاریخ ثبت",
            formatter(value, key, item) {
              return persianDate.getDateByFormat(value);
            },
          },
          {
            key: "amount",
            label: "مبلغ (ریال)",
            formatter(value, key, item) {
              return Number(value > 0 ? value : value * -1).toLocaleString();
            },
          },
          {
            key: "tracking_number",
            label: "کد رهگیری",
          },
          {
            key: "status",
            label: "وضعیت",
            formatter(value, key, item) {
              if (item.amount < 0 && item.parent_id == null) {
                return "در حال تسویه";
              } else if (item.amount > 0 && item.tracking_number != null) {
                return "تسویه شده";
              }
            },
            tdClass(value, key, item) {
              if (item.amount < 0 && item.parent_id == null) {
                return "text-primary";
              } else if (item.amount > 0 && item.tracking_number != null) {
                return "text-success";
              }
            },
          },
        ],
        params: [
          {
            label: "از تاریخ:",
            field: "date_from",
            type: "date-picker",
          },
          {
            label: "تا تاریخ:",
            field: "date_to",
            type: "date-picker",
          },
        ],
        btns: [],
      },
      disableSave: false,
      disablePay: false,
      error: null,
      isloading: false,
      isloadingSaveAndSend: false,
      loadingTable: false,
      itemToSave: {},
      userCards: [],
      gateway: {},
      undoneshare: [],
      doneshare: [],
      undonetable: {
        visibility: true,
        btns: [
          {
            icon: "trash",
            handler: (row) => {
              this.dataLoaded = false;
              this.undonetable.visibility = false;
              httpHelper
                .getData("removeSharing/" + row.did)
                .then((res) => {
                  this.undonetable.visibility = true;
                  this.undonetable.url =
                    "share/undone/" +
                    this.$route.params.id +
                    "?t=" +
                    new Date().getTime();
                })
                .catch((e) => {
                  this.undonetable.visibility = true;
                });
            },
          },
        ],
        url: "share/undone/" + this.$route.params.id,
        fields: [
          {
            key: "id",
            label: "کد درخواست",
          },
          {
            key: "shaba_number",
            label: "شماره شبا",
          },
          {
            key: "nickname",
            label: "نام صاحب حساب",
          },
          {
            key: "title",
            label: "بانک",
          },
          {
            key: "amount",
            label: "مبلغ",
            formatter(value, key, item) {
              return Number(value).toLocaleString() + " ریال";
            },
          },
          {
            key: "created_at",
            label: "تاریخ ثبت",
            formatter(value, key, item) {
              return persianDate.getDateByFormat(value);
            },
          },
          {
            key: "created_at2",
            label: "ساعت ثبت",
            formatter(value, key, item) {
              return persianDate.getTime(item.created_at);
            },
          },
          {
            key: "btns",
            label: "عملیات",
          },
        ],
        params: [],
      },
      donetable: {
        // url: `share/list/${this.$route.params.id}`,
        url: `~reports/api/user-transfers?gateway_id=${this.$route.params.id}`,
        ChargeAccountUrl: `share/list/${this.$route.params.id}?&type=1`,
        TransferDone: `share/list/${this.$route.params.id}?&type=2`,
        TransferUndone: `share/list/${this.$route.params.id}?&type=3`,
        fields: [
          {
            key: "created_at",
            label: "تاریخ درخواست",
            formatter(value, key, item) {
              return moment(value, "YYYY/MM/DDThh:mm:ss").format(
                "jYYYY/jMM/jDD | H:m:s"
              );
            },
            tdClass: "ltr-dir",
          },
          {
            key: "website_name",
            label: "نام وبسایت",
          },
          {
            key: "nickname",
            label: "نام و نام خانوادگی",
          },

          {
            key: "shaba_number",
            label: "شماره شبا",
          },
          {
            key: "tracking_number",
            label: "کد رهگیری",
          },
          {
            key: "amount",
            label: "مبلغ (ریال)",
            formatter(value, key, item) {
              return Number(value).toLocaleString();
            },
            tdClass(value, key, item) {
              if (value > 0) {
                return "text-success ltr";
              }
              return "text-danger ltr";
            },
          },
          {
            key: "wage",
            label: "کارمزد (ریال)",
            formatter(value, key, item) {
              return Number(value).toLocaleString();
            },
            tdClass(value, key, item) {
              if (value > 0) {
                return "text-success ltr";
              }
              return "text-danger ltr";
            },
          },
          {
            key: "status",
            label: "وضعیت",
          },
        ],
        params: [
          {
            label: "از تاریخ:",
            field: "date_from",
            type: "date-picker",
          },
          {
            label: "تا تاریخ:",
            field: "date_to",
            type: "date-picker",
          },
          {
            label: "نام صاحب حساب:",
            field: "nickname",
            type: "text",
          },
          {
            label: "مبلغ :",
            field: "amount",
            type: "number",
          },
          {
            label: "شماره شبا :",
            field: "shaba_number",
            type: "text",
          },
          {
            label: "کد رهگیری :",
            field: "tracking_number",
            type: "text",
          },
          {
            field: "status",
            label: "وضعیت",
            type: "select",
            value: null,
            options: [
              {
                text: "همه موارد",
                value: null,
              },
              {
                text: "در دست بررسی",
                value: "0",
              },
              {
                text: "انجام شده",
                value: 1,
              },
              {
                text: "لغو شده",
                value: 2,
              },
              {
                text: "عودت شده",
                value: 3,
              },
            ],
          },
          {
            label: "نوع",
            field: "transaction_type",
            type: "select",
            value: null,
            options: [
              {
                text: "همه موارد",
                value: null,
              },
              {
                text: "شارژ",
                value: "deposit",
              },
              {
                text: "برداشت",
                value: "credit",
              },
            ],
          },
          // {
          //   label: "نوع:",
          //   field: "type",
          //   type: "vselect",
          //   value: null,
          //   options: [
          //     { text: "همه", value: null },
          //     { text: "واریز (شارژ حساب)", value: 1 },
          //     { text: "انتقال وجه (انجام شده)", value: 2 },
          //     { text: "انتقال وجه (در دست بررسی)", value: 3 },
          //   ],
          // },
        ],
      },
      window: {
        width: 0,
        height: 0,
      },
      showqrc: false,
      files: "",
      fields: [
        {
          key: "amount",
          label: "مبلغ (ریال)",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
        },
        {
          key: "iban",
          label: "شماره شبا",
        },
        {
          key: "name",
          label: "نام",
        },
        {
          key: "status",
          label: "وضعیت",
          formatter(value, key, item) {
            return value === "valid" ? "معتبر" : "نامعتبر";
          },
          tdClass(value, key, item) {
            return value === "valid" ? "text-success" : "text-danger";
          },
        },
      ],
      isBusyExcel: false,
      searchLength:0,
    };
  },
  components: {
    TableShowData,
    MDDropdown,
    AddCard,
    NumberSeprator,
    "v-select-s": vSelect,
    Button,
    "modal-custom": modal,
    "file-uploader": fileUploader,
  },
  methods: {
    dropdownShouldOpen(VueSelect) { 
      console.log(VueSelect);
      if(this.itemToSave.detail_id==undefined){
        httpHelper.getData("usercards?iban="+VueSelect.search).then((response) => {
        this.userCards = response.result
          .filter(function (o) {
            return o.detailed.length > 0;
          })
          .map((item) => {
            return {
              text: item.shaba_number + " (" + item.nickname + ")",
              value: item.detailed[0].id,
            };
          });
      });
      }
      return VueSelect.open
    },
    doalert() {
      alert("");
    },
    closeTashom() {
      this.itemToSave = {};
      this.$bvModal.hide("newShare");
    },
    Save() {
      this.isloading = true;
      this.disableSave = true;
      httpHelper
        .postData("store-sharing/" + this.$route.params.id, this.itemToSave)
        .then((res) => {
          this.isloading = false;

          if (res.success == true) {
            this.disableSave = false;
            this.closeTashom();
            this.undonetable.url = "";
            this.undonetable.url =
              "share/undone/" +
              this.$route.params.id +
              "?t=" +
              new Date().getTime();
          } else {
            this.error = res.error;
          }
        });
    },
    SaveAndSend() {
      this.isloadingSaveAndSend = true;
      this.disablePay = true;
      this.itemToSave["sendItNow"] = true;
      httpHelper
        .postData("store-sharing/" + this.$route.params.id, this.itemToSave)
        .then((res) => {
          this.isloadingSaveAndSend = false;
          if (res.success == true) {
            this.disablePay = false;
            this.closeTashom();
            this.donetable.url = "";
            this.donetable.url =
              "~reports/api/user-transfers?gateway_id=" +
              this.$route.params.id +
              "&t=" +
              new Date().getTime();
          } else {
            this.error = res.error;
          }
        });
    },
    getCardList(cardid) {
      httpHelper.getData("usercards").then((response) => {
        this.userCards = response.result
          .filter(function (o) {
            return o.detailed.length > 0;
          })
          .map((item) => {
            return {
              text: item.shaba_number + " (" + item.nickname + ")",
              value: item.detailed[0].id,
            };
          });
        if (cardid) {
          //   this.itemToSave.detail_id = _.findIndex(
          //     response.result,
          //     function (o) {
          //       return o.id == cardid;
          //     }
          //   ).detailed[0].id;
          this.$bvModal.show("newShare");
        }
      });
    },
    ShowShareModal() {
      this.error = null;
      this.getCardList();
      this.$bvModal.show("newShare");
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    showModal() {
      this.showqrc = true;
    },
    closeModal() {
      this.showqrc = false;
      this.$store.dispatch(GET_CONTENT_EXCEL, "cancele");
    },
    payExcelList() {
      let status = true;
      this.loadedConentExcel.forEach((element) => {
        if (element.status !== "valid") status = false;
        return;
      });
      if (status === false) {
        this.$makeToast(
          "danger",
          "هشدار",
          "وضعیت شماره شبا معتبر نمی باشد.",
          5000
        );
        return;
      }

      this.isBusyExcel = true;
      let objPay = {};
      Object.assign(objPay, {
        fileId: this.loadedExcelId,
        gatewayId: this.$route.params.id,
      });
      this.$store.dispatch(PAY_WITH_CONTENT_EXCEL, objPay).then((data) => {
        this.isBusyExcel = false;
        if (data.success) {
          this.$makeToast(
            "success",
            "ارسال موفق",
            "اطلاعات با موفقیت ارسال گردید.",
            5000
          );
          this.closeModal();
        } else {
          this.$makeToast("danger", "هشدار", "خطا  در ارسال اطلاعات.", 5000);
        }
      });
    },
    loading(e) {
      // this.$store.dispatch(GET_CONTENT_EXCEL,'cancele')
      this.loadingTable = e;
    },
  },
  mounted() {
    httpHelper.getData("share/gateway/" + this.$route.params.id).then((res) => {
      this.gateway = res.result;
    });
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  computed: {
    loadedConentExcel() {
      return this.$store.getters.loadedConentExcel;
    },
    loadedExcelId() {
      return this.$store.getters.loadedExcelId;
    },
  },
};
</script>
<style >
.center-div {
  display: flex;
  justify-content: center;
  position: absolute;
  margin: auto;
  /* top: 0; */
  right: 0;
  /* bottom: 0; */
  left: 0;
  width: 100%;
  /* height: 100px; */
  border-radius: 3px;
}
.ltr {
  direction: ltr;
}
</style>